module.exports = __webpack_public_path__ + "static/media/title.d7008893.png";